var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgService = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_222",
    d: "M0 0H20V20H0z",
    className: "cls-1",
    transform: "translate(246.143 826.143)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#2e374d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    clipPath: "url(#clip-path)",
    transform: "translate(-246.143 -826.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-time_machine",
    d: "M12.14 4a8.133 8.133 0 0 0-6.783 3.625V5.357H4v4.749h4.749V8.749H6.29a6.751 6.751 0 1 1-.933 3.392H4A8.14 8.14 0 1 0 12.14 4zm-.678 2.713v6.105h4.749v-1.356h-3.392V6.713z",
    className: "cls-1",
    transform: "translate(244.002 824.002)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgService, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/service.562122c1.svg";
export { ForwardRef as ReactComponent };